import { createRouter, createWebHashHistory } from 'vue-router'
import { localGet } from '@/utils'

import Login from '../views/Login.vue'
import Member from '../views/Member.vue'
import SysSet from '../views/SysSet.vue'

const routes = [

  {
    path: '/login',
    component: Login,
    meta: { title: '登录', tier: 0 }
  },
  {
    alias: ['/'],
    path: '/member',
    component: Member,
    meta: { title: '会员', tier: 0, group: 'member' }
  },
  {
    path: '/set',
    component: SysSet,
    meta: { title: '设置', tier: 0, group: 'set' }
  },
  {
    path: '/pwd',
    component: () => import('../views/LoginPwd.vue'),
    meta: { title: '登录密码', tier: 1, group: 'set' }
  },
  {
    path: '/card_sale',
    component: () => import('../views/SaleCard.vue'),
    meta: { title: '售卡', tier: 1, group: 'member' }
  },
  {
    path: '/pick_up',
    component: () => import('../views/PickUp.vue'),
    meta: { title: '核销', tier: 1, group: 'member' }
  },
  {
    path: '/search',
    component: () => import('../views/SearchMember.vue'),
    meta: { title: '查询', tier: 1, group: 'member' }
  },
  {
    path: '/card_consume',
    component: () => import('../views/ConsumeCard.vue'),
    meta: { title: '消费', tier: 1, group: 'member' }
  },
  {
    path: '/card_topup',
    component: () => import('../views/TopupCard.vue'),
    meta: { title: '充值', tier: 1, group: 'member' }
  },
  {
    path: '/coupon_topup',
    component: () => import('../views/TopupCoupon.vue'),
    meta: { title: '充次', tier: 1, group: 'member' }
  },
  {
    path: '/record',
    component: () => import('../views/RecordList.vue'),
    meta: { title: '交易记录', tier: 1, group: 'member' }
  },
  {
    path: '/report',
    component: () => import('../views/ReportCenter.vue'),
    meta: { title: '报表', tier: 1, group: 'member' }
  },
  {
    path: '/order_pickup',
    component: () => import('../views/OrderPickup.vue'),
    meta: { title: '提货', tier: 1, group: 'member' }
  }

]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.path == '/login') {
    // 如果路径是 /login 则正常执行
    next()
  } else {
    // 如果不是 /login，判断是否有 token
    if (!localGet('token')) {
      // 如果没有，则跳至登录页面
      next({ path: '/login' })
    //  next();
    } else {
      // 否则继续执行
      next()
    }
  }

  document.title = to.meta.title
})

export default router
